import React, { useState, useRef, useEffect } from "react";
import { FacturaPago } from "./modalFacturaPago";
import { OtrosImpuestos } from "./modalOtroPago";
import PagosRegistros from "./registrarpagos";
import axios from "axios";

import { Mensaje, MensajeSiNo } from "../../mensajes2";

import { Dimmer } from "../../spinner";
import moment from "moment";
import { FacturaMultaPago } from "./modalFactMultaPago";
import { TasasPagos } from "./modalFacturaTasasPagos";
import { FacturaPublicidadPago } from "./modalFacturaPublicidadPago";
import { validaSoloNumero, formatMoneda } from "../../../util/varios";
import PagosRegistros3 from "./registrarpagos3";

function CajaIngresos3() {
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();

  const [factorCambio, setFactorCambio] = useState(0);
  const [taquilla, setTaquilla] = useState(0);

  const [idtipoimpuesto, setIdtipoimpuesto] = useState(null);
  const [idtipoimpuestos, setIdtipoimpuestos] = useState(null);
  const [tipoImpuesto, setTipoImpuesto] = useState(null);
  const [valor, setValor] = useState(null);

  const [facturas, setFacturas] = useState([]);

  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const idorganizacion = JSON.parse(localStorage.getItem("idorganizacion"));
  const numCaja = JSON.parse(localStorage.getItem("numcaja"));

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const txtNumAtencion = useRef();
  const btnSiguiente = useRef();

  const [mostrarFacturaMulta, setMostrarFacturaMulta] = useState(false);
  const [mostarTasasP, setMostrarTasasP] = useState(false);
  const [mostrarPublicidad, setMostrarPublicidad] = useState(false);
  const [mostrarLicores, setMostrarLicores] = useState(false);

  var op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  useEffect(() => {
    //let obj = JSON.parse(localStorage.getItem('post'));
    //setNumCaja(obj.numCaja);
    // radioFactu.current.checked = true;
    //radioVerifi.current.checked = false;
    seleccionarFacturas();
    seleccionarFactorCambio();
    seleccionarTaquilla();
  }, []);

  const cargarpago = (tipoimpu, tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      /*setTitulo('Error');
      setMsg('El Usuario no Tiene Número de Caja Asignado');
      setMostrar1(true);*/
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuesto(tipo);
    setTipoImpuesto(tipoimpu);
    setValor(valor);
    setMostrar(true);
  };

  const seleccionarFactorCambio = () => {
    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          setFactorCambio(response.data.valor);
        }
      })
      .catch(function (error) {
        /*   setTitulo("ERROR");
        setMsg(error.response.data.message)
        setMostrar5(true)*/
        setActivate(false);
      });
  };

  const seleccionarTaquilla = () => {
    let campos = "caja";
    let id = idusuario;
    let nomtab = "usuario";
    let nomid = "idusuario";
    let nomid2 = "idorganizacion";
    let id2 = idorganizacion;

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}`;
    //setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data[0].caja !== null) {
            if (response.data[0].caja.trim() !== "") {
              setTaquilla(response.data[0].caja.trim());
            } else {
              setTaquilla(numCaja);
            }
          } else {
            setTaquilla(numCaja);
          }
        }
      })
      .catch(function (error) {
        /*   setTitulo("ERROR");
        setMsg(error.response.data.message)
        setMostrar5(true)*/
        setActivate(false);
      });
  };

  const cargarotropago = (tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      /*setTitulo('Error');
      setMsg('El Usuario no Tiene Número de Caja Asignado');
      setMostrar1(true);*/
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrar2(true);
  };

  const cargaroFacturaMulta = (tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      /*setTitulo('Error');
      setMsg('El Usuario no Tiene Número de Caja Asignado');
      setMostrar1(true);*/
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrarFacturaMulta(true);
  };

  const cargaroTasasPago = (tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      /*setTitulo('Error');
      setMsg('El Usuario no Tiene Número de Caja Asignado');
      setMostrar1(true);*/
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrarTasasP(true);
  };

  const cargarPubicidadLicores = (tipoimpu, tipo) => (e) => {
    e.preventDefault();
    if (numCaja === "" || numCaja === null) {
      /*setTitulo('Error');
      setMsg('El Usuario no Tiene Número de Caja Asignado');
      setMostrar1(true);*/
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuesto(tipo);
    setTipoImpuesto(tipoimpu);
    setMostrarPublicidad(true);
  };

  const seleccionarFacturas = () => {
    let campos = "*";
    let nomtab = "factura";
    let fe = "'" + moment.utc(fechaSistema).format("YYYY-MM-DD") + "'";
    let sta = 0;
    let condi = "";
    /*  if (radioFactu.current.checked) {
       condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND status = ${sta}`;
     } else {
       let letra = "'V'";
       condi = ` substring(numfactura, 1, 1) = ${letra} AND status = ${sta}`;
     } */

    let orden = "1";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let fact = [];
          //setFacturas(response.data);
          for (let i = 0; i < response.data.length; i++) {
            fact.push({
              idfactura: response.data[i].idfactura,
              numfactura: response.data[i].numfactura,
              idcontribuyente: response.data[i].idcontribuyente,
              totalinmpuesto: response.data[i].totalinmpuesto,
              totalrecargo: response.data[i].totalrecargo,
              totalinteres: response.data[i].totalinteres,
              idtipoingreso: response.data[i].idtipoingreso,
              fechaemision: response.data[i].fechaemision,
              descripcion: response.data[i].descripcion,
              tablacontribuyente: response.data[i].tablacontribuyente,
              tabladeuda: response.data[i].tabladeuda,
              iddeuda: response.data[i].iddeuda,
              status: response.data[i].status,
              nombrecontri: response.data[i].nombrecontri,
              direccioncontri: response.data[i].direccioncontri,
              cedrif: response.data[i].cedrif,
              totalmulta:
                response.data[i].totalmulta === null
                  ? "0.00"
                  : response.data[i].totalmulta,
              deducible: response.data[i].deducible,
              facturador: response.data[i].facturador,
              totalfactura:
                parseFloat(response.data[i].totalinmpuesto) +
                parseFloat(response.data[i].totalrecargo) +
                parseFloat(response.data[i].totalinteres) +
                parseFloat(
                  response.data[i].totalmulta === null
                    ? "0.00"
                    : response.data[i].totalmulta,
                ) -
                parseFloat(response.data[i].deducible),
              idcomercio: response.data[i].idcomercio,
              tipodeuda: response.data[i].tipodeuda,
            });
          }
          setFacturas(fact);
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);

        //setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleAceptaFactura = () => {
    setMostrar(false);
    seleccionarFacturas();
  };

  const handleAceptaFacturaPublicidad = () => {
    setMostrarPublicidad(false);
    seleccionarFacturas();
  };

  const handleAceptaFacturaMulta = () => {
    setMostrarFacturaMulta(false);
    seleccionarFacturas();
  };

  const handleAceptaFacturaTasa = () => {
    setMostrarTasasP(false);
    seleccionarFacturas();
  };

  const handleAceptaOtroPago = () => {
    setMostrar2(false);
    seleccionarFacturas();
  };

  const handleCloseMensa = () => {
    setMostrar1(false);
  };

  const handleNumeroAtencion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    setFacturas([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      seleccionarRegistro();
      btnSiguiente.current.focus();
    }
  };

  const seleccionarRegistro = () => {
    let numaten =
      txtNumAtencion.current.value.trim() === ""
        ? "0"
        : txtNumAtencion.current.value.trim();
    let fe = "'" + moment.utc(fechaSistema).format("YYYY-MM-DD") + "'";
    let endpoint = `${op.conexion}/api/Caja_Ingreso/seleccionarnumeroatencionpago?fecha=${fe}&numcaja=${numCaja}&taquilla=${taquilla}&numaten=${numaten}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            txtNumAtencion.current.value = response.data[0].numatencion;
            seleccionarDetalle();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "El nùmero no existe.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarDetalle = () => {
    let numaten = txtNumAtencion.current.value;
    let fe = "'" + moment.utc(fechaSistema).format("YYYY-MM-DD") + "'";
    let llamado = "3";
    let endpoint = `${op.conexion}/api/Caja_Ingreso/seleccionarnumeroatencion?numaten=${numaten}&fecha=${fe}&idusuario=${idusuario}&llamado=${llamado}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let fact = [];
          //setFacturas(response.data);
          for (let i = 0; i < response.data.length; i++) {
            fact.push({
              idfactura: response.data[i].idfactura,
              numfactura: response.data[i].numfactura,
              idcontribuyente: response.data[i].idcontribuyente,
              totalinmpuesto: response.data[i].totalinmpuesto,
              totalrecargo: response.data[i].totalrecargo,
              totalinteres: response.data[i].totalinteres,
              idtipoingreso: response.data[i].idtipoingreso,
              fechaemision: response.data[i].fechaemision,
              descripcion: response.data[i].descripcion,
              tablacontribuyente: response.data[i].tablacontribuyente,
              tabladeuda: response.data[i].tabladeuda,
              iddeuda: response.data[i].iddeuda,
              status: response.data[i].status,
              nombrecontri: response.data[i].nombrecontri,
              direccioncontri: response.data[i].direccioncontri,
              cedrif: response.data[i].cedrif,
              totalmulta:
                response.data[i].totalmulta === null
                  ? "0.00"
                  : response.data[i].totalmulta,
              deducible: response.data[i].deducible,
              facturador: response.data[i].facturador,
              totalfactura:
                parseFloat(response.data[i].totalinmpuesto) +
                parseFloat(response.data[i].totalrecargo) +
                parseFloat(response.data[i].totalinteres) +
                parseFloat(
                  response.data[i].totalmulta === null
                    ? "0.00"
                    : response.data[i].totalmulta,
                ) -
                parseFloat(response.data[i].deducible),
              idcomercio: response.data[i].idcomercio,
              tipodeuda: response.data[i].tipodeuda,
            });
          }
          setFacturas(fact);
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarNumAtencion = () => {
    let numaten = txtNumAtencion.current.value;
    let fe = "'" + moment.utc(fechaSistema).format("YYYY-MM-DD") + "'";
    let llamado = "2";
    let endpoint = `${op.conexion}/api/Caja_Ingreso/seleccionarnumeroatencion?numaten=${numaten}&fecha=${fe}&idusuario=${idusuario}&llamado=${llamado}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let fact = [];
          //setFacturas(response.data);
          for (let i = 0; i < response.data.length; i++) {
            fact.push({
              idfactura: response.data[i].idfactura,
              numfactura: response.data[i].numfactura,
              idcontribuyente: response.data[i].idcontribuyente,
              totalinmpuesto: response.data[i].totalinmpuesto,
              totalrecargo: response.data[i].totalrecargo,
              totalinteres: response.data[i].totalinteres,
              idtipoingreso: response.data[i].idtipoingreso,
              fechaemision: response.data[i].fechaemision,
              descripcion: response.data[i].descripcion,
              tablacontribuyente: response.data[i].tablacontribuyente,
              tabladeuda: response.data[i].tabladeuda,
              iddeuda: response.data[i].iddeuda,
              status: response.data[i].status,
              nombrecontri: response.data[i].nombrecontri,
              direccioncontri: response.data[i].direccioncontri,
              cedrif: response.data[i].cedrif,
              totalmulta:
                response.data[i].totalmulta === null
                  ? "0.00"
                  : response.data[i].totalmulta,
              deducible: response.data[i].deducible,
              facturador: response.data[i].facturador,
              totalfactura:
                parseFloat(response.data[i].totalinmpuesto) +
                parseFloat(response.data[i].totalrecargo) +
                parseFloat(response.data[i].totalinteres) +
                parseFloat(
                  response.data[i].totalmulta === null
                    ? "0.00"
                    : response.data[i].totalmulta,
                ) -
                parseFloat(response.data[i].deducible),
              idcomercio: response.data[i].idcomercio,
              tipodeuda: response.data[i].tipodeuda,
            });
          }
          setFacturas(fact);
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const eliminarFactura = (ope) => {
    seleccionarNumAtencion();
  };

  const irSiguiente = () => (e) => {
    e.preventDefault();
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Esta seguro de pasar al siguiente cliente?",
      icono: "confirmacion",
    });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarSiguiente();
  };

  const procesarSiguiente = () => {
    if (txtNumAtencion.current.value.trim() !== "") {
      if (facturas.length > 0) {
        let proce = 0;
        for (let i = 0; i < facturas.length; i++) {
          if (facturas[i].status === 1) {
            proce = proce + 1;
          }
        }

        if (proce > 0) {
          update_ordenatencion();
        }
      } else {
        txtNumAtencion.current.value = parseInt(txtNumAtencion.current.value.trim()) + 1;
        seleccionarNumAtencion();  
      }
    } else {
      /* setTimeout(() => {
        txtNumAtencion.current.value = "";
        setFacturas([]);
        seleccionarRegistro();
      }, 400);   */
      txtNumAtencion.current.value = "";
      setFacturas([]);
      seleccionarRegistro();
    }

    
  };

  const update_ordenatencion = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/Caja_Ingreso/updateordenatencion`;

    let body = {
      numaten: txtNumAtencion.current.value,
      fecha: fechaSistema,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          txtNumAtencion.current.value = parseInt(txtNumAtencion.current.value.trim()) + 1;
          seleccionarNumAtencion();
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <div>
      <div className="row m-0 p-0">
        <div className="col-md-10 col-10 mx-auto" id="scroll">
          <div className="col-md-12 border-azul rounded py-2 mt-5 row mx-auto mb-0 azulGradiant shadow text-light justify-content-between">
            <div className="col-md-7">
              <h3>Orden de Atención al Contribuyente</h3>
            </div>
            <div className="col-md-3 d-flex justify-content-end">
              <a type="button" /*  onClick={cerrar}  */ className="text-light ">
                <i className="fas fa-times mx-2"></i>
                <span className="fw-bold">Salir</span>
              </a>
            </div>
          </div>

          <div
            className="col-md-12 mx-auto row"
            style={{ backgroundColor: "white" }}
          >
            <div className="row mx-auto col-md-12 py-2 mt-2">
              <div class="input-group input-group-sm mb-0 col-md-3 ml-0">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  N° de llamado:
                </span>
                <input
                  type="text"
                  class="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  ref={txtNumAtencion}
                  onKeyUp={handleNumeroAtencion}
                  onBlur={handleNumeroAtencion}
                />
              </div>

              <div className="col-md-5"></div>
              <button
                ref={btnSiguiente}
                onClick={irSiguiente()}
                className=" my-auto btn btn-sm btn-success rounded-pill col-md-2"
              >
                <i class="fa-solid fa-right-to-line"> Siguiente</i>
              </button>

              <div className="ml-auto px-0 col-md-2 azulGradiant rounded row py-1">
                <span className="text-light text-center fw-bold fs-6">
                  {"Valor Euro €: " +
                    formatMoneda(
                      factorCambio
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                </span>
              </div>
            </div>

            <PagosRegistros3
              factorCambio={factorCambio}
              facturas={facturas}
              onHideRenderizar={seleccionarNumAtencion}
              onHideElimina={eliminarFactura}
              onHideCancela={() =>{ txtNumAtencion.current.value = ""; setFacturas([]); }}
              numaten={
                txtNumAtencion.current ? txtNumAtencion.current.value : "0"
              }
            />
          </div>
        </div>
      </div>

      <Dimmer active={activate} inverted></Dimmer>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <FacturaPago
        show={mostrar}
        factorCambio={factorCambio}
        tipo={idtipoimpuesto}
        tipoImpuesto={tipoImpuesto}
        valor={valor}
        onHideCancela={() => setMostrar(false)}
        onHideAcepta={handleAceptaFactura}
      />

      <FacturaMultaPago
        show={mostrarFacturaMulta}
        onHideCancela={() => setMostrarFacturaMulta(false)}
        onHideAcepta={handleAceptaFacturaMulta}
      />

      <TasasPagos
        show={mostarTasasP}
        tipo={0}
        onHideCancela={() => setMostrarTasasP(false)}
        onHideAcepta={handleAceptaFacturaTasa}
        factorCambio={factorCambio}
      />

      <FacturaPublicidadPago
        tipo={idtipoimpuesto}
        tipoImpuesto={tipoImpuesto}
        valor={valor}
        show={mostrarPublicidad}
        onHideCancela={() => setMostrarPublicidad(false)}
        onHideAcepta={handleAceptaFacturaPublicidad}
      />

      <OtrosImpuestos
        show={mostrar2}
        tipo={idtipoimpuestos}
        onHideCancelar={handleAceptaOtroPago}
      />
    </div>
  );
}

export default CajaIngresos3;
